const MUTATION_TYPE = {
  clearTrainingContent: 'clearTrainingContent',
  runValidation: 'runValidation',
  pushTrainings: 'pushTrainings',
  parseTrainingContent: 'parseTrainingContent',
  setTrainings: 'setTrainings',
  setTrainingPagination: 'setTrainingPagination',
  setTrainingContent: 'setTrainingContent',
  setTrainingRole: 'setTrainingRole',
  setTrainingStep: 'setTrainingStep',
  setCurrentStep: 'setCurrentStep',
  setTrainingGroup: 'setTrainingGroup',
  setTrainingMode: 'setTrainingMode',
  setTrainingSettings: 'setTrainingSettings',
  setTrainingId: 'setTrainingId',
  setTrainingAllRoles: 'setTrainingAllRoles',
  setPanels: 'setPanels',
  setSelectedPanel: 'setSelectedPanel',
  setDefaultJsons: 'setDefaultJsons',
  addPanel: 'addPanel',
  updatePanel: 'updatePanel',
  deletePanel: 'deletePanel',
  objectsToFiles: 'objectsToFiles',
  setErrorList: 'setErrorList',
  setFile: 'setFile',
  setMarks: 'setMarks',
  setIsFirstCreatingTrainingStage: 'setIsFirstCreatingTrainingStage',
  setStepNumberForGroupTraining: 'setStepNumberForGroupTraining'
}

const ACTION_TYPE = {
  addTraining: 'addTraining',
  fetchTrainingList: 'fetchTrainingList',
  deleteTraining: 'deleteTraining',
  fetchTrainingContent: 'fetchTrainingContent',
  updateTrainingContent: 'updateTrainingContent',
  validateObjects: 'validateObjects',
  zipCourse: 'zipCourse',
  fetchMarks: 'fetchMarks'
}

const GETTER_TYPE = {
  getTrainings: 'getTrainings',
  getTrainingPagination: 'getTrainingPagination',
  getTrainingContent: 'getTrainingContent',
  getTrainingRole: 'getTrainingRole',
  getTrainingStep: 'getTrainingStep',
  getCurrentStep: 'getCurrentStep',
  getTrainingGroup: 'getTrainingGroup',
  getTrainingMode: 'getTrainingMode',
  getTrainingSettings: 'getTrainingSettings',
  getTrainingId: 'getTrainingId',
  getTrainingAllRoles: 'getTrainingAllRoles',
  getPanels: 'getPanels',
  getTrainingCourse: 'getTrainingCourse',
  getSelectedPanel: 'getSelectedPanel',
  getIsTrainingInitialized: 'getIsTrainingInitialized',
  getElements: 'getElements',
  getErrors: 'getErrors',
  hasErrors: 'hasErrors',
  getParsedPanels: 'getParsedPanels',
  getFilesList: 'getFilesList',
  getFileObject: 'getFileObject',
  getValidationInfo: 'getValidationInfo',
  getResources: 'getResources',
  getMarks: 'getMarks',
  getIsFirstCreatingTrainingStage: 'getIsFirstCreatingTrainingStage',
  getStepNumberForGroupTraining: 'getStepNumberForGroupTraining'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
